import { get, post } from "@libs:axios";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { CamelCasedPropertiesDeep } from "type-fest";

import { FeedbackCreateSchema, FeedbackGetSchema } from "@:openapi";

export interface Feedback {
  GET_ALL: {
    Response: CamelCasedPropertiesDeep<Array<FeedbackGetSchema>>;
  };
  POST: {
    RequestBody: CamelCasedPropertiesDeep<FeedbackCreateSchema>;
    Response: CamelCasedPropertiesDeep<FeedbackGetSchema>;
  };
}

export const feedbackQueryKey = createQueryKeys("feedback", {
  getAll: null,
});

export const useQueryGetAllFeedback = (
  options?: Omit<
    UseQueryOptions<Feedback["GET_ALL"]["Response"], AxiosError>,
    "queryKey"
  >,
) => {
  return useQuery<Feedback["GET_ALL"]["Response"], AxiosError>({
    queryKey: feedbackQueryKey.getAll.queryKey,
    queryFn: () => {
      return get<Feedback["GET_ALL"]["Response"]>("/api/feedback/");
    },
    ...options,
  });
};

export const useMutationCreateFeedback = (
  options?: UseMutationOptions<
    Feedback["POST"]["Response"],
    AxiosError,
    Feedback["POST"]["RequestBody"]
  >,
) => {
  return useMutation({
    mutationFn: (data: Feedback["POST"]["RequestBody"]) => {
      return post<Feedback["POST"]["Response"]>("/api/feedback/", data);
    },
    ...options,
  });
};
